import { render, staticRenderFns } from "./FlawView.vue?vue&type=template&id=187b9c8e&scoped=true"
import script from "./FlawView.vue?vue&type=script&lang=js"
export * from "./FlawView.vue?vue&type=script&lang=js"
import style0 from "./FlawView.vue?vue&type=style&index=0&id=187b9c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b9c8e",
  null
  
)

export default component.exports